import React, { useState } from "react";
import { Input, Form } from "antd";
import TopicDropdown from "../../common/TopicDropdown";

import { useSelector } from "react-redux";

const GroupAdvancedSettings = ({ canManage, formItemLayout }) => {
  const { comments, topic } = useSelector(
    (state) => state.groups.selectedGroup
  );

  const [advancedSettings, setAdvancedSettings] = useState({
    comments: comments || "",
    topic: topic || "",
  });

  return (
    <>
      <Form.Item label="Comments" name="comments" {...formItemLayout}>
        <Input.TextArea
          rows={4}
          placeholder="Enter comments"
          value={advancedSettings.comments}
          disabled={!canManage}
          onChange={(e) =>
            setAdvancedSettings({
              ...advancedSettings,
              comments: e.target.value,
            })
          }
        />
      </Form.Item>

      <Form.Item
        label="Topic"
        name="topic"
        trigger="onSelect"
        getValueFromEvent={(value) => value}
        {...formItemLayout}
      >
        <TopicDropdown title="Select optional topic" disabled={!canManage} />
      </Form.Item>
    </>
  );
};
export default GroupAdvancedSettings;
